export const POS_SHOP_CHECKOUT_STORAGE_KEY = "mmacenter:posShopCheckout:v1";

export function savePosShopCheckout(items) {
  const payload = {
    items: (items || []).map(({ productId, quantity }) => ({
      productId: String(productId),
      quantity: Math.max(1, Math.round(Number(quantity) || 1)),
    })),
  };
  sessionStorage.setItem(POS_SHOP_CHECKOUT_STORAGE_KEY, JSON.stringify(payload));
}

export function readPosShopCheckout() {
  try {
    const raw = sessionStorage.getItem(POS_SHOP_CHECKOUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.items?.length) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPosShopCheckout() {
  sessionStorage.removeItem(POS_SHOP_CHECKOUT_STORAGE_KEY);
}
